<template>
  <div>
    <SiteHeader />
    <div class="page flex-col">
      <img
        class="image_1"
        referrerpolicy="no-referrer"
        src="../lanhu_jigouyulishi/assets/img/SketchPnge6526ecb2fcab0802b546f04824fe8f83db80e06fef6b8cf3b08d187c494f182.png"
      />
      <div class="section_1 flex-col">
        <div class="block_3 flex-col">
          <div class="group_3 flex-row">
            <div class="text-group_1 flex-col">
              <span class="text_13">教育与人才</span>
              <span class="text_14">研究生教育、论文答辩与附录内容展示新闻学与传播学系的人才培养历程与教学活动。</span>
            </div>
          </div>
          <div class="text-wrapper_2">
            <span class="text_15">
              <router-link to="/lanhu_shouye" style="color: inherit; text-decoration: none;">首页</router-link>
              &nbsp;&gt;&nbsp;
              <router-link to="/lanhu_jiaoyuyurencai" style="color: inherit; text-decoration: none;">教育与人才</router-link>
              &nbsp;&gt;&nbsp;
            </span>
            <span class="text_16">研究生教育</span>
          </div>
          <div class="group_4 flex-col"></div>
          <div class="group_5 flex-row justify-between">
            <div class="sidebar-slot">
              <SidebarAccordion
                :sections="sidebarSections"
                active-section-id="education"
                active-item-id="graduate-education"
              />
            </div>
            <div class="group_7 flex-col content-slot">
              <div class="text-wrapper_4 flex-col"><span class="text_19">研究生教育</span></div>

              <div class="content-shell">
                <section
                  v-for="group in groups"
                  :key="group.title"
                  class="gallery-section"
                >
                  <div class="gallery-section__header">
                    <p v-if="group.kicker" class="gallery-section__kicker">{{ group.kicker }}</p>
                    <h2 class="gallery-section__title">{{ group.title }}</h2>
                  </div>

                  <div v-if="group.description" class="gallery-section__description">
                    <p
                      v-for="paragraph in normalizedDescription(group.description)"
                      :key="paragraph"
                    >
                      {{ paragraph }}
                    </p>
                  </div>

                  <div v-if="group.items && group.items.length" class="gallery-grid" :class="`gallery-grid--${group.columns || 2}`">
                    <figure
                      v-for="item in group.items"
                      :key="item.caption"
                      class="gallery-card"
                      :class="{
                        'gallery-card--wide': item.wide,
                        'gallery-card--contain': item.contain
                      }"
                    >
                      <div class="gallery-card__image-frame">
                        <img :src="item.src" :alt="item.caption" loading="lazy" />
                      </div>
                      <figcaption>{{ item.caption }}</figcaption>
                    </figure>
                  </div>
                </section>
              </div>
            </div>
          </div>
        </div>
      </div>
      <SiteFooter
        :notch-width="704"
        notch-left="calc((100vw - 1300px) / 2 + 445px)"
      />
    </div>
  </div>
</template>

<script>
import SiteHeader from '@/components/SiteHeader.vue';
import SiteFooter from '@/components/SiteFooter.vue';
import SidebarAccordion from '@/components/SidebarAccordion.vue';
import { createSidebarSections } from '@/config/secondarySidebar';

export default {
  name: 'LanhuJiaoyuyurencai',
  components: {
    SiteHeader,
    SiteFooter,
    SidebarAccordion
  },
  data() {
    return {
      sidebarSections: createSidebarSections({
        activeSectionId: 'education',
        activeItemId: 'graduate-education'
      }),
      groups: [
        {
          title: '研究生教育概况',
          kicker: '1978-2018',
          columns: 1,
          description: [
            '中国社会科学院研究生院新闻学与传播学系（简称“新闻系”）成立于 1978 年 6 月。根据当时中央领导同志的意见，组建新闻系的目的在于为中央主要新闻单位培养高层次的新闻人才，以解决新闻干部青黄不接的问题。',
            '新闻系最初由人民日报社、新华社和中国社会科学院 3 家共同筹办，其后中国日报社也参与了联合办学。2001 年，新闻系开始由中国社会科学院新闻与传播研究所单独管理。',
            '40 年来，新闻系为中国新闻业培养了大批高素质的领军人才，被誉为中国新闻界的“黄埔军校”。截至 2018 年 7 月，新闻系培养博士研究生 63 人，硕士研究生 797 人。同时，还先后开办了多期在职硕士生课程班，培养学生近千人。目前，该系有博士生导师 7 人，硕士生导师 21 人。'
          ],
          items: []
        },
        {
          title: '第一届研究生毕业合影',
          kicker: '1981',
          columns: 1,
          description: [
            '1981 年 7 月，中国社会科学院研究生院新闻系第一届研究生毕业合影。',
            '前排左起：陈国少、张争、贾德昌、张达、苏金琥、张宗厚、明安香、王奔洲、谢冰岩、戴邦、谭立、赵颖楠、熊蕾、李彩英、孙晓阳、夏晓林、高志华、邢平安、原卿友、赵相如、李德民、张铭清、刘力群、陈祖声。',
            '中排左起：许焕隆、王凤超、张一凡、岳颂东、郭亚夫、陈耕涛、吴鸿业、杨润时、李长群、关群、杨良化、朱习华、易凯、秦新民、张木友、江建国、李松晨、鲍广仁、陈力丹、闵大洪、李祖兴、艾丰、罗茂城、张书政。',
            '后排左起：郭敏功、熊昌义、谢骏、刘国胜、魏亚南、王武录、段心强、李安达、姚赣南、舒小骅、向纯武、窦其文、谷安林、虞绍荣、吴兴华、孙旭培、于宁、张克迅、高原、赵庆华、王平兴、张宝林、黄文福、莫新元、徐东明、邹大毅、魏国强、赵希龙。',
            '说明：入学 86 人，毕业 83 人，照像 73 人。戴松成、洪天国、孟晓云、张岩、朱维群（以上新闻业务专业）等 10 人缺席。'
          ],
          items: [
            {
              src: require('@/views/lanhu_yanjiushengjiaoyu/assets/html/graduate-1981-graduates.jpg'),
              caption: '1981 年 7 月，中国社会科学院研究生院新闻系第一届研究生毕业合影'
            }
          ]
        }
      ]
    };
  },
  methods: {
    normalizedDescription(description) {
      return Array.isArray(description) ? description : [description];
    }
  }
};
</script>

<style scoped lang="css" src="../lanhu_jigouyulishi/assets/index.css" />
<style scoped>
.section_1 {
  min-height: auto;
}

.block_3 {
  min-height: auto;
  padding-bottom: 88px;
}

.group_3 {
  padding-bottom: 36px;
}

.text_14 {
  height: auto;
}

.group_5 {
  align-items: flex-start;
}

.sidebar-slot {
  width: 274px;
  flex: 0 0 274px;
}

.sidebar-slot :deep(.sidebar-accordion) {
  width: 100%;
}

.content-slot {
  flex: 1;
  min-width: 0;
}

.content-shell {
  display: grid;
  gap: 28px;
}

.gallery-section {
  padding: 26px;
  border-radius: 12px;
  border: 1px solid rgba(179, 145, 101, 0.18);
  background:
    linear-gradient(140deg, rgba(248, 242, 233, 0.84), rgba(255, 255, 255, 0) 42%),
    linear-gradient(180deg, #fff, rgba(253, 250, 246, 0.96));
  box-shadow: 0 14px 30px rgba(59, 41, 17, 0.05);
}

.gallery-section__header {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  gap: 20px;
  margin-bottom: 22px;
  padding-bottom: 14px;
  border-bottom: 1px solid rgba(179, 145, 101, 0.16);
}

.gallery-section__kicker {
  margin: 0;
  color: #b28a56;
  font-size: 12px;
  line-height: 1.4;
  letter-spacing: 0.14em;
  text-transform: uppercase;
}

.gallery-section__title {
  margin: 0;
  color: #f25c19;
  font-size: 26px;
  line-height: 1.4;
  font-family: 'Songti SC', 'STSong', 'Noto Serif SC', serif;
  font-weight: 700;
}

.gallery-section__description {
  margin: -4px 0 24px;
  color: #2f2a25;
  font-size: 16px;
  line-height: 2;
  font-family: 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', sans-serif;
}

.gallery-section__description p {
  margin: 0 0 10px;
  text-align: justify;
  text-indent: 2em;
}

.gallery-section__description p:last-child {
  margin-bottom: 0;
}

.gallery-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 20px;
  align-items: start;
}

.gallery-grid--1 {
  grid-template-columns: 1fr;
}

.gallery-card {
  display: flex;
  flex-direction: column;
  min-width: 0;
  margin: 0;
  overflow: hidden;
  border-radius: 12px;
  background: #fff;
  border: 1px solid rgba(179, 145, 101, 0.16);
  box-shadow: 0 10px 24px rgba(45, 33, 16, 0.05);
}

.gallery-card--wide {
  grid-column: span 2;
}

.gallery-card__image-frame {
  width: 100%;
  background: #f6f2ec;
  overflow: hidden;
}

.gallery-card__image-frame img {
  width: 100%;
  height: auto;
  display: block;
  object-fit: contain;
}

.gallery-card figcaption {
  margin: 0;
  padding: 14px 16px 16px;
  color: #4e463d;
  font-size: 14px;
  line-height: 1.8;
  text-align: justify;
  font-family: 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', sans-serif;
}

@media (max-width: 1024px) {
  .group_5 {
    flex-direction: column;
    gap: 24px;
  }

  .sidebar-slot {
    width: 100%;
    flex-basis: auto;
  }

  .gallery-grid {
    grid-template-columns: 1fr;
  }

  .gallery-card--wide {
    grid-column: span 1;
  }
}
</style>
